import React from 'react';
// template components
import AssistiveText from '@nmx/template/dist/componentLibrary/components/AssistiveText';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import CollapsibleTypography from '@nmx/template/dist/componentLibrary/components/CollapsibleTypography';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// styles
import {
  ArticleStyled,
  ColStyledBannerContainer,
  ColStyledCardContentContainer,
  ColStyledDurationContainer,
  ColStyledPlayButtonContainer,
  DivStyledBannerTextContainer,
  LinkStyled,
  LinkStyledPlayButton,
  RowStyledEpisodeCardContent,
  RowStyledPlayButtonContainer,
  TypographyStyledEpisode,
  TypographyStyledSeason,
  TypographyStyledSeasonEpisode,
} from './styles';

const HtmlRenderer = ({ htmlString }) => {
  const renderHtml = () => {
    return { __html: htmlString };
  };
  return (
    <span
      itemProp='description'
      dangerouslySetInnerHTML={renderHtml()}
    />
  );
};

export default ({
  articleLinkPath,
  data,
  itemIndex,
}) => {

  // converts the total seconds sent by the CMS into a human readable HH:MM:SS format
  const convertSecondsToHumanReadableTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = remainingSeconds.toString().padStart(2, '0');
    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  };

  const convertSecondsToISO8601 = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `PT${hours}H${minutes}M${seconds}S`;
  };

  const ensureTrailingSlashOnLink = (url) => {
    if (!url.endsWith('/')) {
      return `${url}/`;
    }
    return url;
  };

  return (
    <ArticleStyled
      itemScope
      itemType='https://schema.org/PodcastEpisode'>
      <AssistiveText
        component='h3'
        itemProp='name'>
        {data.name}
      </AssistiveText>
      <meta
        itemProp='actor'
        content='Jennifer Borget'
      />
      <RowStyledEpisodeCardContent>
        <ColStyledBannerContainer
          small={6}
          medium={12}
          itemIndex={itemIndex}>
          <DivStyledBannerTextContainer>
            <TypographyStyledSeason
              variant='small'
              disableBottomPadding
              weight={500}
              itemIndex={itemIndex}>
              Season&nbsp;
              <span itemProp='partOfSeason'>
                {data.fieldPartOfSeason}
              </span>
            </TypographyStyledSeason>
            <TypographyStyledEpisode
              variant='h2'
              disableBottomPadding
              itemIndex={itemIndex}>
              Episode&nbsp;
              <span itemProp='episodeNumber'>
                {data.episodeNumber}
              </span>
            </TypographyStyledEpisode>
          </DivStyledBannerTextContainer>
        </ColStyledBannerContainer>
        <ColStyledCardContentContainer
          small={6}
          medium={12}>
          <TypographyStyledSeasonEpisode
            ariaLabel={`Season ${data.fieldPartOfSeason} episode ${data.episodeNumber}`}
            variant='eyebrow'
            disableBottomPadding>
            S{data.fieldPartOfSeason}&nbsp;:&nbsp;episode&nbsp;{data.episodeNumber}
          </TypographyStyledSeasonEpisode>
          <Typography
            variant='h4'
            disableBottomPadding>
            <LinkStyled
              variant='primaryDeemphasize'
              linkUrl={`/life-and-money${ensureTrailingSlashOnLink(articleLinkPath)}`}
              isInternalPdf
              itemProp='url'>
              {data.name}
            </LinkStyled>
          </Typography>
        </ColStyledCardContentContainer>
        <Col nested>
          <CollapsibleTypography
            clampedLines={3}
            backgroundVariant='lightB'
            buttonContentCollapsed={<>&#8230;Read more</>}
            buttonContentExpanded={<>&#8230;Read less</>}
            typographyProps={{
              nextElement: 'button',
              variant: 'p2',
              children: '', // required prop, not being used
            }}>
            <HtmlRenderer
              htmlString={data.fieldEpisodeAbstract.value}
            />
          </CollapsibleTypography>
        </Col>
      </RowStyledEpisodeCardContent>
      <RowStyledPlayButtonContainer>
        <ColStyledPlayButtonContainer>
          <LinkStyledPlayButton
            linkUrl={data.fieldCohostEpisodeUrl.url.path}
            ariaLabel={`Play episode ${data.episodeNumber} from season ${data.fieldPartOfSeason}`}
            isOutgoingLink
            itemProp='url'>
            <AssistiveText>
              Play episode
            </AssistiveText>
          </LinkStyledPlayButton>
        </ColStyledPlayButtonContainer>
        <ColStyledDurationContainer>
          <meta
            itemProp='duration'
            content={convertSecondsToISO8601(data.fieldDuration)}
          />
          <Typography
            variant='p2'
            disableBottomPadding>
            {convertSecondsToHumanReadableTime(data.fieldDuration)}
          </Typography>
        </ColStyledDurationContainer>
      </RowStyledPlayButtonContainer>
    </ArticleStyled>
  );
};
